import React from 'react';

import Accordion from '../../Accordion';

import * as S from './styles';

function DependentsDetails({ dataBeneficiario }) {
    let dependentes = [];

    if (dataBeneficiario?.dependentes?.length > 0) {
        dependentes = dataBeneficiario?.dependentes.reduce((newObj, dependente) => {
            const obj = { ...newObj };

            if (!newObj[dependente?.plano?.nome]) obj[dependente?.plano?.nome] = [];

            obj[dependente?.plano?.nome].push(dependente);

            return obj;
        }, {});
    }

    const dependentesByPlan = Object.keys(dependentes).map((key) => (
        <>
            <span className="key">{key}</span>
            {dependentes[key].map((dependente) => (
                <span key={dependente?.nome}>
                    {dependente?.nome} - {dependente?.tipo}
                </span>
            ))}
            <br />
        </>
    ));

    return (
        <S.Details>
            <Accordion title="Dependentes desta pessoa titular" hasCollapse={false}>
                <S.DepList>{dependentesByPlan}</S.DepList>
            </Accordion>
        </S.Details>
    );
}

export default DependentsDetails;
